import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createHaulerDetailViewRoutesMap } from './id'

export const createHaulerRoutesMap = (prefix: string) => ({
  // PRO-89: the breadcrumb never says "Hauler Details" — this node is a
  // contractor in the module's one vocabulary.
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainMapAuto(createHaulerDetailViewRoutesMap, {
      title: <T _str="Contractor" />,
      breadCrumbTitle: <T _str="Contractor" />,
    }),
  create: pathJoin(prefix)('create').chainMapAuto((prefix2) => ({
    configuration: pathJoin(prefix2)('configuration').chainWithTitle({
      title: <T _str="New contractor" />,
      breadCrumbTitle: <T _str="New contractor" />,
    }),
  })),
})
